import { useNavigate } from 'react-router-dom';
import { ModuleName } from '@/constants';

export function useAppNavigation() {
  const navigate = useNavigate();

  // navigate to a player's detail page
  interface IGoToPlayerPageProps {
    playerId: number;
    module?: ModuleName;
    state?: Record<string, unknown>;
  }

  const goToPlayerPage = ({ playerId, module, state }: IGoToPlayerPageProps) => {
    if (!playerId) {
      console.warn('Invalid player data provided to goToPlayerPage');
      return;
    }

    const params = new URLSearchParams();
    if (module) {
      params.set('module', module);
    }

    navigate(`/tourbag/${playerId}?${params.toString()}`, {
      replace: false,
      state,
    });
  };

  // navigate back to the tour bag list
  const goToTourBagPage = () => {
    navigate('/tourbag', { replace: true });
  };

  return {
    goToPlayerPage,
    goToTourBagPage,
  };
}
